import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    template_test: {},
    questions: [],
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_TEMPLATE_TEST_TO_MANAGE:
            return {
                ...state,
                template_test: payload.template_test,
                questions: payload.questions,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/manage-template-test/manage-template-test.reducer.js